import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { GlobalIconNames } from "../../../utils/GlobalIconNames";
import ListofRegisteredStudents from "../../StudentAdministration/registration/ListofRegisteredStudents";
import ListofNewRegistrations from "../../StudentAdministration/registration/ListofNewRegistrations";
import ListofReRegistrations from "../../StudentAdministration/registration/ListofReRegistrations";
import ListofSLPRegistrations from "../../StudentAdministration/registration/ListofSLPRegistrations";

/**
 * Dashboard tabs for Registration/Re-Registration.
 * Renders the same table components used on /studentadministration/registration/studentlist/{tab}
 * so both places share one React Query cache for equal filters/pagination.
 */
const ListofRegistrationDashboard = () => {
  const history = useHistory();
  const { type } = useParams();

  return (
    <>
      <div className="tabs-wrap">
        <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
          <li
            className="nav-item"
            onClick={() => history.push("/home/registration/all")}
          >
            <a
              className={`nav-link cursor-pointer ${type === "all" || !type ? "active" : ""}`}
              data-toggle="pill"
              role="tab"
              aria-selected="true"
            >
              {GlobalIconNames("registration").html}
            </a>
          </li>
          <li
            className="nav-item"
            onClick={() => history.push("/home/registration/registrationsonly")}
          >
            <a
              className={`nav-link cursor-pointer ${type === "registrationsonly" ? "active" : ""}`}
              data-toggle="pill"
              role="tab"
              aria-selected="true"
            >
              {GlobalIconNames("registrationsonly").html}
            </a>
          </li>
          <li
            className="nav-item"
            onClick={() => history.push("/home/registration/reregistrationsonly")}
          >
            <a
              className={`nav-link cursor-pointer ${type === "reregistrationsonly" ? "active" : ""}`}
              data-toggle="pill"
              role="tab"
              aria-selected="true"
            >
              {GlobalIconNames("reregistrationsonly").html}
            </a>
          </li>
          <li
            className="nav-item"
            onClick={() => history.push("/home/registration/slpregistrationsonly")}
          >
            <a
              className={`nav-link cursor-pointer ${type === "slpregistrationsonly" ? "active" : ""}`}
              data-toggle="pill"
              role="tab"
              aria-selected="true"
            >
              {GlobalIconNames("slpregistrationsonly").html}
            </a>
          </li>
        </ul>
      </div>
      {type === "registrationsonly" ? (
        <ListofNewRegistrations isDashboard={true} />
      ) : type === "reregistrationsonly" ? (
        <ListofReRegistrations isDashboard={true} />
      ) : type === "slpregistrationsonly" ? (
        <ListofSLPRegistrations isDashboard={true} />
      ) : (
        <ListofRegisteredStudents isDashboard={true} />
      )}
    </>
  );
};

export default ListofRegistrationDashboard;
